<template>
    <div class="controlItemWrapper" :class="control.className" :data-control-name="control.name">
        <div class="controlItem row" :id="control.name" v-if="labelPosition === 'left'">
            <div class="col-md-4">
                <label :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}">
                    {{control.label}}
                </label>
            </div>
            <div class="col-md-8 input-group">
                <input type="text" class="form-control"
                       :readonly="control.readonly"
                       :name="control.fieldName"
                       :value="demo_value">

                <div class="input-group-append">
                        <span class="input-group-text">
                            <font-awesome-icon :icon="icon" />
                        </span>
                </div>
            </div>
        </div>
        <div class="controlItem row" :id="control.name" v-else>
            <div class="form-group col-md-12">
                <label :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}">
                    {{control.label}}
                </label>
                <div class="input-group">
                    <input type="text" class="form-control"
                           :readonly="control.readonly"
                           :name="control.fieldName"
                           :value="demo_value">

                    <div class="input-group-append">
                        <span class="input-group-text">
                            <font-awesome-icon :icon="icon" />
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {CONTROL_TYPES} from "@/components/DataGrid/FormBuilder/config/control_constant";
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    export default {
        name: "NumberControl",
        props: ['control', 'labelPosition'],
        components: {
            FontAwesomeIcon
        },
        data: () => ({
            icon: CONTROL_TYPES.number.icon
        }),
        computed: {
            demo_value() {
                if (!_.isEmpty(this.control.defaultValue)) {
                    return this.control.defaultValue;
                }

                if (this.control.isInteger) {
                    return 0;
                } else {
                    let decimal = parseInt(this.control.decimalPlace);
                    let x = 0;
                    return x.toFixed(decimal);
                }
            }
        }
    }
</script>

<style scoped>

</style>
